import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";

import type { SocialPlatform } from "@/lib/orgSocialHandles";
import { cn } from "@/lib/utils";

/** X has no lucide glyph; this is the official mark as a path. */
const XIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

/** Brand colour per platform, used by both the editor card and the profile row. */
export const SOCIAL_PLATFORM_COLORS: Record<SocialPlatform, { text: string; bg: string }> = {
  instagram: { text: "text-pink-500", bg: "bg-pink-500/10" },
  facebook: { text: "text-[#1877F2]", bg: "bg-[#1877F2]/10" },
  linkedin: { text: "text-[#0A66C2]", bg: "bg-[#0A66C2]/10" },
  youtube: { text: "text-[#FF0000]", bg: "bg-[#FF0000]/10" },
  x: { text: "text-foreground", bg: "bg-muted" },
};

interface SocialPlatformIconProps {
  platform: SocialPlatform;
  className?: string;
}

export function SocialPlatformIcon({ platform, className }: SocialPlatformIconProps) {
  switch (platform) {
    case "instagram":
      return <Instagram className={className} aria-hidden="true" />;
    case "facebook":
      return <Facebook className={className} aria-hidden="true" />;
    case "linkedin":
      return <Linkedin className={className} aria-hidden="true" />;
    case "youtube":
      return <Youtube className={className} aria-hidden="true" />;
    case "x":
      // The X mark is visually heavier than the lucide set at equal size.
      return <XIcon className={cn(className, "scale-[0.85]")} />;
  }
}
